<template>
  <nav class="navbar navbar-expand-lg custom-navbar">

    <div class="container-fluid">

      <!-- Logo -->
      <router-link class="navbar-brand" to="/">
          <div class="logo-wrapper">
         <img :src="require('@/assets/logo_step_edge_web-3.png')" alt="StepEdge Academy"  />
          </div>
        
      </router-link>

     <!-- Toggler -->
    <button
      class="navbar-toggler"
      type="button"
      @click="toggleMenu"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
      

      <!-- Menu -->
        <div
      class="collapse navbar-collapse"
      :class="{ show: menuOpen }"
    >

      <ul class="navbar-nav ms-auto">

          <li 
            class="nav-item"
            v-for="(link,index) in navLinks"
            :key="index"
          >


            <!-- Dropdown item -->
            <template v-if="link.subMenu">

              <a
                class="nav-link dropdown-toggle text-white"
                href="#"
                @click.prevent="toggleDropdown(index)"
              >
                {{ link.name }}
              </a>


              <!-- Vue controlled dropdown -->
              <ul
                class="dropdown-menu  custom-dropdown-menu"
                :class="{ show: openDropdown === index }"
              >

                <li
                  v-for="(sub,j) in link.subMenu"
                  :key="j"
                >

                  <router-link
                    class="dropdown-item"
                    :to="sub.path"
                    @click="closeAll"
                  >
                    {{ sub.name }}
                  </router-link>

                </li>

              </ul>

            </template>


            <!-- Normal link -->
            <template v-else>

              <router-link
                class="nav-link text-white"
                :to="link.path"
                @click="closeAll"
              >
                {{ link.name }}
              </router-link>

            </template>


          </li>

        </ul>

      </div>

    </div>

  </nav>
    <!-- Breadcrumb.vue or directly inside a layout component -->
  <AppBreadcrumb />
</template>


<script>
import AppBreadcrumb from './AppBreadcrumb.vue';
export default {
   components: {
    AppBreadcrumb,
  },

  data() {

    return {

      menuOpen:false,

      openDropdown:null,


      navLinks:[
      { name: 'Home', path: '/' },
      { name: 'About Us', path: '/about-us' },
      {
        name: 'Secondary',
        subMenu: [
          { name: 'Computer Science', path: '/computer-science' },
           { name: 'Computational Thinking', path: '/computational-thinking' },
           { name: 'Artificial Intelligence', path: '/artificial-intelligence' },
          { name: 'Exam Boards', path: '/exam-boards' },
         
        ]
      },
      { name: 'School Partnerships', path: '/school-partnerships' },
      { name: 'Teaching Approach', path: '/teaching' },
       { name: 'Digital Ecosystem', path: '/digital-learning-ecosystem' },
      //{ name: 'Courses', path: '/courses' },
      { name: 'Testimonials', path: '/testimonials' },
      { name: 'Contact Us', path: '/contact' }
      //{ name: 'Blog', path: '/blog' }
    ]

    }

  },


  methods:{


    toggleMenu(){

      this.menuOpen = !this.menuOpen

    },


    toggleDropdown(index){

      if(this.openDropdown === index)
      {
        this.openDropdown = null
      }
      else
      {
        this.openDropdown=index
      }

    },


    closeAll(){

      this.menuOpen=false
      this.openDropdown=null

    }


  }

}

</script>


<style scoped>


/* Vue controlled dropdown */

.dropdown-menu.show{

  display:block;

}


.custom-navbar {
  background-color: #1B5E20; /* dark green */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.navbar-nav .nav-link {
  color: white;
  transition: background-color 0.3s, color 0.3s;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

.navbar-nav .nav-link:hover {
  background-color: #ffffff; /* White background on hover */
  color: #155724 !important;; /* Dark green text */
}

/* Dropdown Styling */

.custom-dropdown-menu {
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0;
}

.custom-dropdown-menu .dropdown-item {
  color: #155724; /* Dark green text */
}

.custom-dropdown-menu .dropdown-item:hover {
  background-color: #1B5E20; /* dark green */  /* light green hover */
  color: #ffffff !important; /* darker green on hover */
}
/* Make dropdown position correctly */
.nav-item.dropdown {
  position: relative;
}


/* logo css */
.logo-box {
  background-color: white;
  padding: 1px 16px;
  border-radius: 8px;
  display: inline-block;
  text-align: center;
}
.logo-text {
  font-family: 'Cinzel', serif; /* or Merriweather or Playfair Display */
  font-size: 23px;
  color: #2E7D32;
}
.logo-char {
  font-size: 36px;
}
.logo-sub {
  font-family: 'Cinzel', serif;
  font-size: 20px;
  color: #81C784;
}

.logo-wrapper img {
  height: 130px;
  width: auto;
}
.navbar-toggler-icon {
  filter: brightness(0); /* solid black */
}

</style>